import { Question } from 'generated-graphql/types';
import { isNumber } from 'utils/validation';

export const sortQuestions = (a: Question, b: Question) => {
  if (isNumber(a.order) && isNumber(b.order)) {
    return (a.order as number) - (b.order as number);
  }

  if (isNumber(a.order)) {
    return -1;
  }

  if (isNumber(b.order)) {
    return 1;
  }

  return 0;
};
